import { api } from "@/lib/api";

const CHUNK = 4 * 1024 * 1024; // 4 MB per chunk — safely under proxy limits

// Upload a large video via chunked transfer, returns the created photo doc.
export async function uploadVideoChunked(file, opts = {}, onProgress) {
  const init = await api.post("/media/upload/init", (() => {
    const fd = new FormData();
    fd.append("filename", file.name || "video.mp4");
    return fd;
  })(), { headers: { "Content-Type": "multipart/form-data" } });
  const { upload_id, ext } = init.data;

  const total = file.size;
  let sent = 0;
  let index = 0;
  for (let start = 0; start < total; start += CHUNK) {
    const blob = file.slice(start, Math.min(start + CHUNK, total));
    const fd = new FormData();
    fd.append("upload_id", upload_id);
    fd.append("index", index);
    fd.append("ext", ext);
    fd.append("file", blob, "chunk");
    // eslint-disable-next-line no-await-in-loop
    await api.post("/media/upload/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    sent += blob.size;
    index += 1;
    onProgress?.(Math.round((sent / total) * 100));
  }

  const { data } = await api.post("/media/upload/complete", {
    upload_id, ext, filename: file.name || "video.mp4",
    privacy: opts.privacy || "private", album: opts.album || null,
    reuse_permission: opts.reuse || "private",
    usable_on_sites: opts.sites || [],
    make_public: !!opts.makePublic,
  });
  return data;
}

export const isVideoFile = (f) =>
  (f.type || "").startsWith("video/") || /\.(mp4|mov|m4v|webm|avi|mkv)$/i.test(f.name || "");
